export const SPLIT_TEST_DISABLED_COOKIE_NAME = 'splitTestsDisabled';
export const SPLIT_TEST_DISABLED_COOKIE_VALUE = '1';
export const areSplitTestsDisabled = (cookies) => {
    return cookies[SPLIT_TEST_DISABLED_COOKIE_NAME] === SPLIT_TEST_DISABLED_COOKIE_VALUE;
};
//# sourceMappingURL=areSplitTestsDisabled.js.map